import createCollectionStore from '../create';
import { fetchAll, saveCustomer } from '../../core-data';
import { Customer } from '../../core-data/types';
import UUID from 'uuid';

export default createCollectionStore(
  'Customer',
  false,
  () => fetchAll(Customer),
  'uuid',
  [],
  {
    save: async (state, actions, customer) => {
      const modified = {
        uuid: UUID.v4(),
        ...customer
      };
      await saveCustomer(modified);
      await actions.updateCache(modified);
      return { };
    }
  }
);



// WEBPACK FOOTER //
// ./src/services/collection/collections/customer.js